var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_9632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24H6C4.4087 24 2.88258 23.3679 1.75736 22.2426C0.632141 21.1174 0 19.5913 0 18V6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0L18 0C19.5913 0 21.1174 0.632141 22.2426 1.75736C23.3679 2.88258 24 4.4087 24 6V18C24 19.5913 23.3679 21.1174 22.2426 22.2426C21.1174 23.3679 19.5913 24 18 24Z",
    fill: "#2864B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 6.75H18C18.8659 6.75109 19.6992 6.41929 20.3273 5.82325C20.9555 5.2272 21.3305 4.41252 21.3748 3.54772C21.4191 2.68292 21.1293 1.83417 20.5654 1.17704C20.0015 0.519908 19.2065 0.104682 18.345 0.01725C18.2303 0.010875 18.1166 0 18 0H6C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6L0 18C0 15.0163 1.18526 12.1548 3.29505 10.045C5.40483 7.93526 8.26632 6.75 11.25 6.75Z",
    fill: "#417DCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12C16.8133 12 15.6533 12.3519 14.6666 13.0112C13.6799 13.6705 12.9109 14.6075 12.4567 15.7039C12.0026 16.8003 11.8838 18.0067 12.1153 19.1705C12.3468 20.3344 12.9182 21.4035 13.7574 22.2426C14.5965 23.0818 15.6656 23.6532 16.8295 23.8847C17.9933 24.1162 19.1997 23.9974 20.2961 23.5433C21.3925 23.0892 22.3295 22.3201 22.9888 21.3334C23.6481 20.3467 24 19.1867 24 18V6C24 7.5913 23.3679 9.11742 22.2426 10.2426C21.1174 11.3679 19.5913 12 18 12Z",
    fill: "#0F4B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.375H5.25C4.83579 9.375 4.5 9.71079 4.5 10.125V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H6.75C7.16421 19.5 7.5 19.1642 7.5 18.75V10.125C7.5 9.71079 7.16421 9.375 6.75 9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.875C7.03553 7.875 7.875 7.03553 7.875 6C7.875 4.96447 7.03553 4.125 6 4.125C4.96447 4.125 4.125 4.96447 4.125 6C4.125 7.03553 4.96447 7.875 6 7.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 10.74C13.0524 10.2114 13.4891 9.77201 14.0159 9.46645C14.5428 9.16089 15.141 8.99998 15.75 9C17.6576 9 19.5 10.125 19.5 13.125V18.75C19.5 18.9489 19.421 19.1397 19.2803 19.2803C19.1397 19.421 18.9489 19.5 18.75 19.5H17.25C17.0511 19.5 16.8603 19.421 16.7197 19.2803C16.579 19.1397 16.5 18.9489 16.5 18.75V13.5C16.5 13.0027 16.3025 12.5258 15.9508 12.1742C15.5992 11.8225 15.1223 11.625 14.625 11.625C14.1277 11.625 13.6508 11.8225 13.2992 12.1742C12.9475 12.5258 12.75 13.0027 12.75 13.5V18.75C12.75 18.9489 12.671 19.1397 12.5303 19.2803C12.3897 19.421 12.1989 19.5 12 19.5H10.5C10.3011 19.5 10.1103 19.421 9.96967 19.2803C9.82902 19.1397 9.75 18.9489 9.75 18.75V10.125C9.75 9.92609 9.82902 9.73532 9.96967 9.59467C10.1103 9.45402 10.3011 9.375 10.5 9.375H12C12.1989 9.375 12.3897 9.45402 12.5303 9.59467C12.671 9.73532 12.75 9.92609 12.75 10.125V10.74Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_9632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.a308d2786c3b230dab62584163e86ce5.svg";
export { ForwardRef as ReactComponent };